import type { CSSProperties } from 'react';

import type { LayoutPoint, ViewerPosition } from '../contracts/models';

export interface MeasurementPolygonProps {
  points: readonly LayoutPoint[];
  hoverPoint?: ViewerPosition | null;
  active?: boolean;
  pointerEvents?: CSSProperties['pointerEvents'];
}

/**
 * Shared in-progress AreaTag geometry used by both image and PDF layouts.
 * Persistence and measurement-mode policy remain the host's responsibility.
 */
export const MeasurementPolygon = ({
  points,
  hoverPoint = null,
  active = false,
  pointerEvents,
}: MeasurementPolygonProps) => {
  if (points.length === 0) {
    if (!active || !hoverPoint) return null;
    return (
      <circle
        cx={hoverPoint.x}
        cy={hoverPoint.y}
        r="4"
        fill="#4477ff"
        stroke="white"
        strokeWidth={2}
        pointerEvents="none"
      />
    );
  }

  const lastPoint = points[points.length - 1];

  return (
    <g style={pointerEvents ? { pointerEvents } : undefined}>
      <polygon
        className="polygon active"
        points={points.map((point) => point.join(',')).join(' ')}
        fill="rgba(100, 149, 255, 0.306)"
        stroke="#4477ff"
        strokeWidth={2}
      />
      {points.map((point, index) => (
        <g key={`${point[0]}-${point[1]}-${index}`}>
          <circle
            className="point-marker"
            cx={point[0]}
            cy={point[1]}
            r="3"
            fill="#4477ff"
            stroke="white"
            strokeWidth={2}
          />
          <text
            className="point-label"
            x={point[0] + 5}
            y={point[1] - 5}
            fontSize="12"
            fill="black"
            fontFamily="Arial, sans-serif"
          >
            {index + 1}
          </text>
        </g>
      ))}
      {active && hoverPoint && (
        <>
          <line
            x1={lastPoint[0]}
            y1={lastPoint[1]}
            x2={hoverPoint.x}
            y2={hoverPoint.y}
            stroke="#4477ff"
            strokeWidth={2}
            strokeDasharray="6,4"
            pointerEvents="none"
          />
          <circle
            cx={hoverPoint.x}
            cy={hoverPoint.y}
            r="4"
            fill="#4477ff"
            stroke="white"
            strokeWidth={2}
            pointerEvents="none"
          />
        </>
      )}
    </g>
  );
};
